import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X, ShieldCheck } from "lucide-react";

const navLinks = [
  { name: "Home", path: "/", end: true },
  { name: "Products", path: "/products" },
  { name: "Services", path: "/services" },
  { name: "About", path: "/about" },
  { name: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => setIsOpen(false);

  return (
    <>
      <nav className="navbar navbar-expand-lg fixed-top tw-bg-slate-950/95 tw-backdrop-blur-md tw-border-b tw-border-white/10 tw-shadow-[0_8px_30px_rgba(0,0,0,0.25)]">
        <div className="container">
          <Link
            to="/"
            onClick={closeMenu}
            className="navbar-brand d-flex align-items-center gap-2 tw-text-white tw-font-bold tw-text-[1.55rem] tw-no-underline"
          >
            <div className="tw-w-10 tw-h-10 tw-rounded-2xl tw-bg-cyan-400/10 tw-border tw-border-cyan-400/20 tw-flex tw-items-center tw-justify-center">
              <ShieldCheck size={21} className="tw-text-cyan-400" />
            </div>
            <span className="tw-tracking-tight">CyberShield</span>
          </Link>

          <button
            className="navbar-toggler tw-border-0 tw-shadow-none tw-p-2"
            type="button"
            onClick={() => setIsOpen((prev) => !prev)}
            aria-label="Toggle navigation"
            aria-expanded={isOpen}
          >
            <div className="tw-w-11 tw-h-11 tw-rounded-xl tw-bg-white/5 tw-border tw-border-white/10 tw-flex tw-items-center tw-justify-center">
              {isOpen ? (
                <X size={20} className="tw-text-white" />
              ) : (
                <Menu size={20} className="tw-text-white" />
              )}
            </div>
          </button>

          <div className={`collapse navbar-collapse ${isOpen ? "show" : ""}`}>
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-lg-center tw-gap-2 tw-mt-3 tw-mt-lg-0">
              {navLinks.map((link) => (
                <li className="nav-item" key={link.name}>
                  <NavLink
                    to={link.path}
                    end={link.end}
                    onClick={closeMenu}
                    className={({ isActive }) =>
                      [
                        "nav-link",
                        "tw-relative",
                        "tw-px-4",
                        "tw-py-2.5",
                        "tw-rounded-2xl",
                        "tw-font-medium",
                        "tw-text-[15px]",
                        "tw-transition-all",
                        "tw-duration-300",
                        isActive
                          ? "tw-text-white tw-bg-cyan-400/15 tw-border tw-border-cyan-400/30 tw-shadow-[0_0_0_1px_rgba(34,211,238,0.08)]"
                          : "tw-text-slate-200 hover:tw-text-white hover:tw-bg-white/5 tw-border tw-border-transparent",
                      ].join(" ")
                    }
                  >
                    {({ isActive }) => (
                      <span className="tw-flex tw-items-center tw-gap-2">
                        {isActive && (
                          <span className="tw-w-2 tw-h-2 tw-rounded-full tw-bg-cyan-400 tw-inline-block" />
                        )}
                        {link.name}
                      </span>
                    )}
                  </NavLink>
                </li>
              ))}

              <li className="nav-item tw-ms-0 tw-ms-lg-3">
                <NavLink
                  to="/contact"
                  onClick={closeMenu}
                  className="btn tw-bg-cyan-400 hover:tw-bg-cyan-300 tw-text-slate-950 tw-font-semibold tw-rounded-2xl tw-px-5 tw-py-2.5 tw-border-0 tw-shadow-[0_10px_25px_rgba(34,211,238,0.25)]"
                >
                  Get a Demo
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <style>{`
        .navbar-brand,
        .nav-link {
          text-decoration: none;
        }

        .navbar .nav-link {
          color: #e2e8f0 !important;
        }

        .navbar .nav-link:hover {
          color: #ffffff !important;
        }

        .navbar .nav-link.active {
          color: #ffffff !important;
          background: rgba(34, 211, 238, 0.14) !important;
          border: 1px solid rgba(34, 211, 238, 0.30) !important;
        }

        .navbar-toggler:focus,
        .btn:focus,
        .nav-link:focus {
          box-shadow: none !important;
        }

        @media (max-width: 991.98px) {
          .navbar .navbar-collapse {
            margin-top: 12px;
            padding: 16px;
            border-radius: 20px;
            background: rgba(2, 6, 23, 0.96);
            border: 1px solid rgba(255,255,255,0.08);
          }

          .navbar .nav-link {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
}